import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { RolesPermissions } from './RolesPermissions';
import { PersonalData } from './PersonalData';
import { ChangePassword } from './ChangePassword';
import PropTypes from 'prop-types';

export const Profile = ({ userLogged, user }) => (
  <>
    <Row className="g-3">
      <Col xs={12} md={6} lg={4}>
        <Row className="g-3">
          <Col xs={12}>
            <PersonalData user={user} userLogged={userLogged} />
          </Col>

          {userLogged?.id === user?.id && (
            /*userLogged?.typeOfUser !== 'admin' &&*/
            <Col xs={12}>
              <ChangePassword user={user} />
            </Col>
          )}
        </Row>
      </Col>

      <Col xs={12} md={6} lg={8}>
        <RolesPermissions user={user} userLogged={userLogged} />
      </Col>
    </Row>
  </>
);
Profile.propTypes = {
  userLogged: PropTypes.object,
  user: PropTypes.object
};
